module.exports = __webpack_public_path__ + "b.no2.38a0ddfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/b.no2.jpg
// module id = Oj0Q
// module chunks = 0